import {Link} from "react-router-dom";
import ExperiencePanel from "@/components/jarvis/ExperiencePanel";
import "./Operations.css";
export default function Experience(){return <main className="operations-page"><header><Link to="/mas">← Todos los módulos</Link><p className="hud-label">TU EXPERIENCIA / A TU MEDIDA</p><h1>Accesibilidad<span>.</span></h1><p>Texto, contraste, movimiento y consumo de recursos.</p></header><ExperiencePanel/></main>}
